<template>
  <WsMain>
    <WsBreadCrumbs
      :items="breadcrumbs.items"
      class="mb-3"
    ></WsBreadCrumbs>
    <template>
      <WsCRUD
        v-for="(field, fieldKey) in _fields"
        :ref="`WsCRUD_${fieldKey}`"
        :key="fieldKey"
        noChangePage
        :hasMultiDeleteBtn="field.hasMultiDeleteBtn"
        :isMultiSelect="_isStageFinished ? false : field.isMultiSelect"
        :modelName="field.modelName"
        :label="field.label"
        :fields="field.fields"
        :showExpand="field.showExpand"
        :inRowBtnDelete="field.inRowBtnDelete"
        :inRowBtnUpdate="field.inRowBtnUpdate"
        :inRowBtnRead="field.inRowBtnRead"
        :isCreatable="field.isCreatable"
        :isFilterShow="field.isFilterShow"
        :filterSelects="field.filterSelects"
        :showFields="field.showFields"
        :hasSearchBtn="field.hasSearchBtn"
        :getUrl="field.getUrl"
        :getParams="field.getParams"
        :id="field.id ? `${field.id}` : `${field.versionId}`"
        :versionId="field.versionId"
        :isPaginationShow="field.isPaginationShow"
        :isVtabsShow="field.isVtabsShow"
        :tabFields="field.tab? field.tab.items : null"
        :preTabValue="field.tab ? field.tab.value : ''"
        :filterProps="field.filterProps"
        :displayHideFields="field.displayHideFields"
        :updateHideFields="field.updateHideFields"
        :customHideFields="field.customHideFields"
        :titleKey="field.readDialogTitleKey"
        :orderBy="field.orderBy"
        :orderWay="field.orderWay"
        :pageMode="field.pageMode"
        :style="{'margin-bottom': fieldKey === 'related_template' ? '100px' : '20px'}"
        @filter-select="$_onFilterSelect($event, fieldKey)"
        @set-modelDatas="$_onSetModelDatas($event, fieldKey)"
        @tab-switched="$_onTabSwitch($event, fieldKey)"
      >
        <template v-slot:titlebarCustomBtns>
          <WsIconBtn
            v-if="fieldKey === 'article'"
            :size="40"
            tooltip="分頁檢視"
            @click="$_onToggleSplitPane"
          >
            mdi-open-in-new
          </WsIconBtn>
        </template>
        <template v-slot:customBtns="{ item, modelDatas, tabValue }">
          <WsIconBtn
            v-for="(btn, btnIndex) in field.inRowCustomBtns"
            :ref="`iconBtn_${fieldKey}_${btn.value}_${item.id}`"
            :key="btnIndex"
            :tooltip="btn.tooltip"
            tooltipPosition="top"
            class="ml-1 mr-1"
            :disabled="item[`${btn.disabledKey}`]"
            :isLoading="item.btnLoading"
            @click="
              $_onInRowBtnClick(fieldKey, item, btn, modelDatas, tabValue)
            "
            >{{ btn.icon }}</WsIconBtn
          >
        </template>
        <template
          v-slot:customDialog="{
            customFields,
            updateFields,
            displayFields,
            errorMessages,
            titleKey,
            modelDatas
          }"
        >
          <WsUpdateDialog
            :ref="`checkFailDialog_${fieldKey}`"
            :label="field.label"
            :fields="customFields"
            :modelName="field.modelName"
            :errorMessages="errorMessages"
            :isLoading="isLoading.checkFailDialog"
            @update-submit="$_onSaveRemark(fieldKey, $event, modelDatas)"
          />
          <WsUpdateDialogCompare
            isCloseScrollTop
            :ref="`updateDialog_${fieldKey}`"
            :label="field.label"
            :fields="updateFields"
            :modelName="field.modelName"
            :errorMessages="errorMessages"
            :customBtns="field.updateDialogSetting.customBtns"
            :getCompareDialogValueFunction="field.getCompareDialogValueFunction"
            :isLoading="isLoading.updateDialog"
            @custom-emit="$_onDialogCustomAction($event, fieldKey, 'update')"
            @update-submit="$_onUpdateDialogSubmit($event, fieldKey)"
          />
          <WsReadDialogCompare
            isCloseScrollTop
            :ref="`readDialog_${fieldKey}`"
            :fields="displayFields"
            :titleKey="titleKey"
            :customBtns="field.readDialogSetting.customBtns"
            :getCompareDialogValueFunction="field.getCompareDialogValueFunction"
            :isLoading="isLoading.readDialog"
            @custom-emit="$_onDialogCustomAction($event, fieldKey, 'read')"
          />
        </template>
        <template v-slot:multiSelectCustomBtns="{items, modelDatas}">
          <WsBtn
            @click="$_onBatchPass(fieldKey, modelDatas, items, field.inRowCustomBtns)"
          >
            <v-icon left>mdi-check</v-icon> 批次通過
          </WsBtn>
        </template>
      </WsCRUD>
    </template>
    <WsMainBottomNav v-if="!_isStageFinished">
      <div
        v-for="(btn, btnIndex) in statusBtnList"
        :key="btnIndex"
        class="d-flex align-center mr-2"
      >
        <v-chip
          small
          :color="btn.color"
          class="mr-1"
        />
        <div
          class="text-center"
          :style="{'line-height': '40px'}"
        >{{ `: ${btn.text}` }}</div>
      </div>
      <v-icon
        v-if="!_isCheckedAll"
        size="20"
        color="alert"
        class="mr-1"
      >mdi-alert-circle</v-icon>
      <div
        v-if="!_isCheckedAll"
        class="text-center alert--text"
        :style="{'line-height': '40px'}"
      >尚有{{ _remainingItems }}法規或法條或相關公版沒有進行鑑別</div>
      <WsBtn
        :disabled="!_isCheckedAll"
        :loading="isLoading.submit || isLoading.batchPass"
        @click="$_onOpenPopup('WsAlertDialog')"
      >{{ _customBtns.title }}</WsBtn>
    </WsMainBottomNav>
    <WsAlertDialog
      ref="WsAlertDialog"
      color="primary"
      btnText="確認完成"
      title="確認完成法規總覆核鑑別作業嗎？"
      :description="submit.description"
      @submit="$_onSubmit(_customBtns.submitUrl)"
    />
    <WsAlertDialog
      ref="resultDialog"
      :title="resultDialog.title"
    >
      <template v-slot:bottom-btn>
        <WsBtn
          color="primary"
          @click="$_onConfirmResultDialog"
        >確認</WsBtn>
      </template>
    </WsAlertDialog>
    <LvSplitPanes
      ref="LvSplitPanes"
      :idtfAssignmentId="modelData && modelData[1] ? modelData[1].id : null"
      :leftFetchParams="_leftFetchParams"
      :rightFetchParams="_rightFetchParams"
      :rightDisplayFields="_rightDisplayFields"
      :setSplitPaneData="$_getSetSplitPaneData()"
      :getCompareDialogValueFunction="_fields && _fields.article && _fields.article.getCompareDialogValueFunction ? _fields.article.getCompareDialogValueFunction : null"
      :stage="subModelName"
      @close="$_onCloseSplitPane"
    />
  </WsMain>
</template>

<script>
import S_idtf from "@/services/api/v1/idtf";
import H_idtf from "@/helpers/idtf";
import Spare_idtf from "@/spare/idtf";

export default {
  name: "Review",
  data() {
    return {
      modelName: 'act_idtf_assignment_items',
      subModelName:'overall_review_result',
      subModelSubmitUrl: `act_idtf_assignment/${this.$route.params.id}/act_idtf_assignment_item/idtf_overall/review`,
      modelData: [],
      updateData: {
        overall_review_result: [],
      },
      isLoading: {
        submit: false,
        updateDialog: false,
        readDialog: false,
        checkFailDialog: false,
        batchPass: false,
      },
      breadcrumbs: {
        fields:[
          {
            text: "我的總覆核鑑別作業",
            url: "/idtf_review_overall",
            disabled: false,
          },
          {
            getText: function (modelData) {
              return modelData[1].act_version.name;
            },
            getUrl: function (modelData) {
              const id = modelData[1].id;
              return `/idtf_review_overall/${id}`;
            },
            disabled: false,
          },
          {
            text: "總覆核鑑別",
            disabled: true,
          },
        ],
        items: [],
      },
      fields: {
        article: {
          filterProps: {},
        },
        related_template: {
          filterProps: {},
        },
      },
      idtfItemsNumber: null,
      submit: {
        description: '',
      },
      resultDialog: {
        isReviewSuccess: false,
        title: '',
      },
      statusBtnList: Spare_idtf.statusBtnList,
    };
  },
  async mounted() {
    await this.$_fetchData();
    this.breadcrumbs.items = this.$_getBreadcrumbsItems();
  },
  methods: {
    async $_fetchData() {
      try {
        const idtfContent = await S_idtf.show(this._idtfId);
        const idtfItems = await S_idtf.indexAllIdtfItems(this._idtfId);
        this.idtfItemsNumber = idtfItems.length;
        this.modelData = [idtfItems, idtfContent];
        this.$_initUpdateData(idtfItems);
      } catch (error) {
        alert(error)
      }
    },
    $_onFilterSelect($event, fieldKey) {
      this.$set(this.fields[fieldKey], "filterProps", $event);
    },
    async $_onUpdateDialogSubmit($event, fieldKey) {
      const fields = this._fields[fieldKey];
      const updateDialog = this.$_getUpdateDialog(fieldKey);
      try {
        updateDialog.startLoading();
        const formattedUpdateData = fields.setUpdateData
          ? fields.setUpdateData($event, this.modelData)
          : $event;
        const indexInUpdateData = H_idtf.getUpdateDataIndex(
          this.updateData[fieldKey],
          'id',
          $event.id
        );
        H_idtf.updateUpdateData(this.updateData, formattedUpdateData, fieldKey, indexInUpdateData);
        if (fields.updateIdtfItems) fields.updateIdtfItems(this.modelData[0], $event);
        await this.$_updateCRUDData($event, fieldKey);
        const { getSubmitUrl, setSubmitData } = fields;
        if (getSubmitUrl) {
          const submitData = setSubmitData ? setSubmitData(formattedUpdateData) : formattedUpdateData;
          await this.$axios.patch(getSubmitUrl({
            id: $event.id,
            modelData: this.modelData,
            updateData: formattedUpdateData
          }), submitData);
        }
        updateDialog.stopLoading();
        if (updateDialog.$refs.updateDialog.dialog) updateDialog.close();
      } catch (error) {
        alert(error)
        updateDialog.stopLoading();
      }
    },
    async $_updateCRUDData($event, fieldKey){
      const modelDatas = this.$_getWsCRUD(fieldKey).modelDatas;
      for (let modelData of modelDatas) {
        if (modelData.id === $event.id) {
          modelData.dot = H_idtf.setDot(modelData, this.subModelName);
          for (let key in this._fields[fieldKey].fields) {
            const field = this._fields[fieldKey].fields[key];
            if (field.isValueUpdatable) {
              try {
                await S_idtf.updateCRUDData($event, field, modelData, key, this.subModelName)
              } catch(error) {
                alert(error)
              }
            }
          }
        }
      }
    },
    async $_onSubmit(submitUrl) {
      this.isLoading.submit = true
      this.$refs.WsAlertDialog.startLoading();
      try {
        await this.$axios.post(submitUrl)
        this.$refs.WsAlertDialog.stopLoading();
        this.isLoading.submit = false;
        this.$_onClosePopup('WsAlertDialog');
        this.resultDialog.isReviewSuccess = true;
        this.resultDialog.title = '法規總覆核鑑別作業完成';
        this.$_onOpenPopup('resultDialog');
      } catch (error) {
        this.$refs.WsAlertDialog.stopLoading();
        this.isLoading.submit = false
        this.$_onClosePopup('WsAlertDialog');
        this.resultDialog.isReviewSuccess = true;
        this.resultDialog.title = '法規總覆核鑑別作業完成';
        this.$_onOpenPopup('resultDialog');
      }
    },
    async $_onInRowBtnClick(fieldKey, item, btn, modelDatas, tabValue) {
      const tarIndex = modelDatas.findIndex(e => e.id == item.id);
      const tarModelData = modelDatas[tarIndex];
      const btnType = btn.type;
      if (btn.value !== undefined) {
        item.btnLoading = true;
        btn.action(item);
        const isCheckedValueSame = modelDatas[tarIndex][this.subModelName] == btn.value;
        const formattedData = this.$_setValueInUpdateData(fieldKey, { ...item, value: btn.value }, isCheckedValueSame, modelDatas);
        modelDatas[tarIndex][this.subModelName] = formattedData[this.subModelName];
        await this.$axios.post(this.subModelSubmitUrl, {
          'act_idtf_assignment_items': [formattedData],
        });
        item.dot = H_idtf.setDot(formattedData, this.subModelName);
        item.btnLoading = false;
        const fields = this._fields[fieldKey];
        if (fields.updateIdtfItems) fields.updateIdtfItems(this.modelData[0], {isCheckedValueSame, id: item.id, [this.subModelName]: `${btn.value}`});
        if (btn.value === 0 && !isCheckedValueSame) {
          this.$_getCheckFailDialog(fieldKey).open(tarModelData);
        }
      } else if (btnType === "update" || btnType === "read") {
        const loadingType = {
          update: "updateDialog",
          read: "readDialog",
        };
        const field = this._fields[fieldKey];
        if (!btn.action) {
          this.$refs[`${btnType}Dialog_${fieldKey}`][0].open({});
        }
        if (field.fetchDialogData) {
          this.isLoading[loadingType[btnType]] = true;
          try {
            await field.fetchDialogData(tarModelData);
          } catch (error) {
            alert(error);
          }
          this.isLoading[loadingType[btnType]] = false;
        }
        if (btn.action) {
          btn.action(item, tabValue, this);
        } else {
          const dialogData = field.setDialogShowData ? field.setDialogShowData(tarModelData) : tarModelData;
          this.$refs[`${btnType}Dialog_${fieldKey}`][0].open(dialogData);
        }
      }
    },
    $_setValueInUpdateData(fieldKey, $event, isCheckedValueSame, modelDatas) {
      const tarId = $event.id;
      const tarModelData = modelDatas.find(data => data.id === tarId);
      const versionId = H_idtf.getVersionId($event, this.modelData, this._fields[fieldKey].getVersionId, tarModelData)
      const versionKey = H_idtf.getVersionKey(this._fields[fieldKey].tab, this._fields[fieldKey].modelName)
      let data = {
        [`${versionKey}`]: versionId ? versionId : $event.id,
        [this.subModelName]: $event.value,
        [this.subModelName]: isCheckedValueSame ? null : $event.value,
      };
      const id = this._fields[fieldKey].getIdtfAssigmentItemId($event, this.modelData[0], versionKey, versionId);
      data = id ? { ...data, id } : data
      const index = H_idtf.getUpdateDataIndex(
        this.updateData[`${this.subModelName}`],
        versionKey,
        versionId
      )
      if (!isCheckedValueSame) {
        H_idtf.updateUpdateData(this.updateData, data, this.subModelName, index);
      } else {
        this.updateData[`${this.subModelName}`].splice(index, 1);
      }
      return data;
    },
    $_getBreadcrumbsItems() {
      if (!this.modelData || !this.breadcrumbs) return;
      const _breadcrumbsItems = H_idtf.getBreadcrumbsItems(this.modelData, this.breadcrumbs.fields)
      return _breadcrumbsItems;
    },
    async $_onSaveRemark(fieldKey, $event, modelDatas) {
      this.isLoading.checkFailDialog = true;
      const fields = this._fields[fieldKey];
      const id = $event.id;
      const tarModelData = modelDatas.find(data => data.id === id);
      const versionId = H_idtf.getVersionId($event, this.modelData, fields.getVersionId, tarModelData)
      const versionKey = H_idtf.getVersionKey(fields.tab, fields.modelName)
      const index = H_idtf.getUpdateDataIndex(
        this.updateData[`${this.subModelName}`],
        versionKey,
        versionId
      )
      for (let key in $event) {
        if (key !== "id") {
          this.updateData[this.subModelName][index] = {
            ...this.updateData[this.subModelName][index],
            [`${key}`]: $event[key],
          };
        }
      }
      const formattedData = this.updateData[this.subModelName][index];
      if (fields.updateIdtfItems) fields.updateIdtfItems(this.modelData[0], formattedData);
      try {
        await this.$axios.post(this.subModelSubmitUrl, {
          'act_idtf_assignment_items': [formattedData],
        });
      } catch (error) {
        alert(error)
      } finally {
        this.isLoading.checkFailDialog = false;
        this.$_getCheckFailDialog(fieldKey).close();
      }
    },
    $_onTabSwitch($event, fieldKey) {
      this._fields[fieldKey].tab.value = $event;
    },
    async $_onDialogCustomAction($event, fieldKey, type) {
      const field = this._fields[fieldKey];
      if (type === 'read') {
        this.$_getReadDialog(fieldKey).close();
        const isClickCheckButton = $event.value !== undefined
          ? true
          : false
        if (isClickCheckButton) {
          this.$refs[`iconBtn_${fieldKey}_${$event.value}_${$event.item.id}`][0].$_onClick();
        } else {
          const item = $event.item;
          this.$_getUpdateDialog(fieldKey).open({});
          if (field.fetchDialogData) {
            this.isLoading.updateDialog = true;
            try {
              await field.fetchDialogData(item);
            } catch (error) {
              alert(error);
            }
            this.isLoading.updateDialog = false;
          }
          const dialogData = field.setDialogShowData ? field.setDialogShowData(item) : item;
          this.$_getUpdateDialog(fieldKey).open(dialogData);
        }
      } else if (type === 'update') {
        const dialogData = field.setDialogShowData ? field.setDialogShowData($event) : $event;
        this.$_getReadDialog(fieldKey).open(dialogData);
        this.$_getUpdateDialog(fieldKey).close();
      }
    },
    $_onSetModelDatas(modelData, fieldKey) {
      const keys = [
        'll_comment',
        'idtf_check_result',
        'idtf_review_result',
        "overall_review_result",
        "overall_review_remark",
        "overall_review_updated_admin",
        "overall_review_updated_at",
      ];
      H_idtf.setModelDatas(modelData, fieldKey, keys, this.updateData, this.subModelName, this._fields[fieldKey]);
    },
    $_getUpdateDialog(fieldKey) {
      return this.$refs[`updateDialog_${fieldKey}`][0]
    },
    $_getReadDialog(fieldKey) {
      return this.$refs[`readDialog_${fieldKey}`][0]
    },
    $_getWsCRUD(fieldKey) {
      return this.$refs[`WsCRUD_${fieldKey}`][0]
    },
    $_getCheckFailDialog(fieldKey) {
      return this.$refs[`checkFailDialog_${fieldKey}`][0]
    },
    $_onOpenPopup(type) {
      const actionList = {
        'WsAlertDialog': () => {
          let isItemFail = false;
          this.updateData[this.subModelName].forEach(item => {
            if (item[this.subModelName] == 0) isItemFail = true;
          })
          this.submit.description = isItemFail
            ? '有法規或法條不通過，送出之後，將退回上一關「覆核法規鑑別作業」，並且此法規鑑別狀態將會是「覆核中」。'
            : '送出之後，將會「發布法規」，並且此法規內容格式狀態將會是「完成」、鑑別狀態將會是「完成」。';
          this.$refs.WsAlertDialog.open();
        },
        'resultDialog': () => this.$refs.resultDialog.open(),
      };
      if (actionList[type]) actionList[type]();
    },
    $_onClosePopup(type) {
      const actionList = {
        WsAlertDialog: () => this.$refs.WsAlertDialog.close(),
        resultDialog: () => {
          this.resultDialog.isReviewSuccess = false;
          this.$refs.resultDialog.close();
        },
      };
      if (actionList[type]) actionList[type]();
    },
    async $_onBatchPass(fieldKey, modelDatas, selectedItems, btnList) {
      this.isLoading.batchPass = true;
      const btn = btnList.find(btn => btn.value === 1);
      const selectedItemIdList = selectedItems.map(item => item.id);
      const RowItemList = this.$refs[`WsCRUD_${fieldKey}`][0].$refs.WsDataTable._items;
      const task = [];
      modelDatas.forEach((modelData, modelDataIndex) => {
        if (selectedItemIdList.includes(modelData.id) && !modelDatas[modelDataIndex][this.subModelName]) {
          const tarRowItem = RowItemList.find(item => selectedItemIdList.includes(item.id) && item.id === modelData.id);
          btn.action(tarRowItem);
          const formattedData = this.$_setValueInUpdateData(fieldKey, { ...tarRowItem, value: btn.value }, false, modelDatas);
          modelDatas[modelDataIndex][this.subModelName] = btn.value;
          task.push(this.$axios.post(this.subModelSubmitUrl, {
            'act_idtf_assignment_items': [formattedData],
          }));
          tarRowItem.btnLoading = true;
          tarRowItem.dot = {color: 'green'};
        }
      })
      await Promise.all(task);
      RowItemList.forEach(item => item.btnLoading = false);
      this.isLoading.batchPass = false;
    },
    $_initUpdateData(idtfItems) {
      const subModelName = this.subModelName;
      const idIndexMap = new Map(this.updateData[subModelName].map((item, index) => [item.id, index]));
      const validItems = idtfItems.filter(item =>
        item[subModelName] == '1' || item[subModelName] == '0'
      );
      const versionKeys = H_idtf.setVersionKeys(this.subModelName);
      validItems.forEach(item => {
        const updateItem = {
          id: item.id,
          [this.subModelName]: item[this.subModelName],
        };
        const versionData = versionKeys.reduce((acc, key) => {
          if (item[key] && item[key].id) {
            acc[key] = item[key].id;
          }
          return acc;
        }, {});
        const newUpdateData = { ...updateItem, ...versionData };
        if (idIndexMap.has(item.id)) {
          const index = idIndexMap.get(item.id);
          this.$set(this.updateData[subModelName], index, newUpdateData);
        } else {
          this.updateData[subModelName].push(newUpdateData);
        }
      });
    },
    $_onConfirmResultDialog() {
      if (this.resultDialog.isReviewSuccess) this.$router.push(this.breadcrumbs.fields[0].url);
      this.$_onClosePopup('resultDialog');
    },
    $_onToggleSplitPane() {
      this.$refs.LvSplitPanes.open();
    },
    $_getSetSplitPaneData() {
      if (!this._fields || !this._fields.article || !this._fields.article.setSplitPaneData) return;
      return (rawData) => this._fields.article.setSplitPaneData(rawData, this._actVersionId, this.modelData[0]);
    },
    async $_onCloseSplitPane() {
      await this.$_fetchData();
      const articleCRUD = this.$_getWsCRUD('article');
      await articleCRUD.$_fetchData();
    },
  },
  computed: {
    _idtfId() {
      return this.$route.params.id;
    },
    _fields() {
      let fields = H_idtf.setFields(this.modelData, this.subModelName, false, this._isStageFinished);
      for (let key in fields) {
        fields[key] = {
          ...fields[key],
          ...this.fields[key],
        };
      }
      return fields;
    },
    _customBtns() {
      return {
        title: "完成總覆核",
        submitUrl: `act_idtf_assignment/${this.$route.params.id}/overall_review/complete`,
      };
    },
    _remainingItems() {
      return this.idtfItemsNumber - this._checkedNum;
    },
    _isCheckedAll() {
      return this._remainingItems === 0;
    },
    _checkedNum() {
      return this.updateData[this.subModelName].length;
    },
    _actVersionId() {
      if (!this.modelData || !this.modelData[1] || !this.modelData[1].act_version) return null;
      return this.modelData[1].act_version.id;
    },
    _leftFetchParams() {
      return {
        order_way: 'asc',
        order_by: 'no_number',
        lang: 'tw',
        act_versions: this._actVersionId,
        act_version: this._actVersionId
      };
    },
    _rightFetchParams() {
      return {
        order_way: 'asc',
        order_by: 'no_number',
        lang: 'tw',
        act_versions: this._actVersionId,
      };
    },
    _rightDisplayFields() {
      if (!this._fields || !this._fields.article || !this._fields.article.fields) return [];
      const { fields: allFields, displayHideFields } = this._fields.article;
      return Object.entries(allFields).filter(([key]) => !displayHideFields.includes(key) && key !== this.subModelName && key !== this._remarkKey);
    },
    _remarkKey() {
      return Spare_idtf.remarkKeyList[this.subModelName];
    },
    _isStageFinished() {
      return H_idtf.isStageFinished(this.modelData[1], this.subModelName);
    }
  },
};
</script>